<template>
    <div class="news">
        <router-view class="router" :keyword="searchKeyword" :callback="onResult"></router-view>
        <div class="btn-menu" @click="showBackButton = !showBackButton">
            <a-icon type="menu-unfold" v-if="showBackButton"/>
            <a-icon type="menu-fold" v-if="!showBackButton"/>
        </div>
        <div :class="{'menus': true, 'show': !showBackButton}">
            <div class="search-box">
                <select v-model="categoryId">
                    <option value="">所有分類</option>
                    <option value="6">學會訊息</option>
                    <option value="7">學會課程</option>
                    <option value="8">活動預告</option>
                    <option value="9">醫學新聞</option>
                    <option value="10">健康資訊</option>
                </select>
                <input type="text" v-model="keyword" class="keyword" placeholder="請輸入搜索關鍵字" @keyup="onKeyUp">
                <button @click="doSearch"><a-icon type="search" class="icon"/>搜索</button>
            </div>

            <div class="list" v-if="listNews.length">
                <div class="head"><a-icon type="bars" class="icon"/>相關資訊</div>
                <ul class="datas">
                    <li class="item" v-for="(news, index) in listNews" :key="index">
                        <router-link :to="`/AssociationNews/details/${news.newsid}`" v-text="news.title"></router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from '../../components/Loading'
export default {
    components: {
        Loading,
    },
    data(){
        return {
            mode: 'top',
            title: '',
            keyword: '',
            categoryId: '',
            searchKeyword: '',
            detail: null,
            loading: false,
            listNews: [],
            showBackButton: true,
        }
    },
    mounted: function(){
        this.keyword = this.$route.query.keyword || ''
        this.categoryId = this.$route.query.CatID || ''
    },
    methods: {
        onResult: function(newsList) {
            this.listNews = newsList || []
        },
        onKeyUp: function(e) {
            if(e.key === 'Enter') {
                this.doSearch()
            }
        },
        doSearch: function(){
            this.showBackButton = true
            var keyword = this.keyword.trim()
            var list = []
            if(this.categoryId) {
                list.push(`CatID=${this.categoryId}`)
            }
            if(keyword) {
                list.push(`keyword=${keyword}`)
            }
            var path = `/AssociationNews/list`
            if(list.length) {
                path = `/AssociationNews/list?${list.join('&')}`
            }
            if(location.href.endsWith(path)) {
                this.searchKeyword = null
                setTimeout(() => {
                    this.searchKeyword = keyword
                }, 10)
            } else {
                this.$router.push(path)
            }
        },
        onRefresh: function(){
            this.loading = true
            setTimeout(() => {
                this.loading = false
                this.detail = {}
            }, 1500)
        }
    },
    watch: {
        '$route.query.CatID': function(categoryId) {
            this.categoryId = categoryId || ''
        },
        '$route.query.keyword': function(keyword) {
            this.keyword = keyword || ''
        },
    }
}
</script>

<style scoped>
    .news {
        width: 1000px;
        margin: 0px auto;
        display: flex;
    }

    .news > .router {
        flex: 1;
        margin-right: 20px;
    }

    .news > .menus {
        width: 260px;
        display: flex;
        flex-direction: column;
    }

    .news > .menus > .search-box {
        width: 100%;
        box-sizing: border-box;
        background-color: #FAF7EF;
        border: 1px solid #e8e8e8;
        display: flex;
        flex-direction: column;
        padding: 12px 24px;
        align-items: center;
    }
    
    .news > .menus > .search-box > select,
    .news > .menus > .search-box > input {
        width: 100%;
        height: 33px;
        line-height: 33px;
        padding-left: 12px;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        color: #232323;
        font-weight: 400;
        font-size: 14px;
        margin-bottom: 10px;
    }

    .news > .menus > .search-box > button {
        margin-top: 20px;
        height: 33px;
        width: 80px;
        border: 1px solid #e8e8e8;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        border-radius: 4px;
        color: #232323;
        font-size: 16px;
        font-weight: 400;
        box-shadow: inset 0 1px 0 rgba(255,255,255,.15), 0 1px 1px rgba(0,0,0,.075);
    }

    .news > .menus > .search-box > button:active {
        opacity: 0.7;
    }

    .news > .menus > .search-box > button > .icon {
        margin-right: 8px;
    }

    .news > .menus > .list {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        box-shadow: 2px 2px 3px #e8e8e8;
    }

    .news > .menus > .list > .head {
        height: 33px;
        line-height: 33px;
        padding-left: 12px;
        font-size: 16px;
        font-weight: bold;
        color: #31708f;
        background-image: linear-gradient(to bottom,#d9edf7 0,#c4e3f3 100%);
    }

    .news > .menus > .list > .head > .icon {
        margin-right: 8px;
    }

    .news > .menus > .list > .datas {
        padding: 0 12px;
        position: relative;
    }

    .news > .menus > .list > .datas > .item {
        line-height: 30px;
        position: relative;
        box-sizing: border-box;
        font-size: 15px;
        font-weight: 400;
        color: #333;
        border-bottom: 1px dashed #e8e8e8;
        padding-left: 33px;
        overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
    }

    .news > .menus > .list > .datas > .item::after {
        content: '1';
        background-color: #d9534f;
        position: absolute;
        left: 7px;
        top: 7px;
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        color: #fff;
        font-size: 12px;
        border-radius: 2px;
        font-weight: 400;
    }
    
    .news > .menus > .list > .datas > .item:nth-child(2)::after {
        content: '2';
        background-color: #d9534f;
    }
    
    .news > .menus > .list > .datas > .item:nth-child(2)::after {
        content: '2';
        background-color: #d9534f;
    }
    
    .news > .menus > .list > .datas > .item:nth-child(2)::after {
        content: '2';
        background-color: #d9af4f;
    }
    
    .news > .menus > .list > .datas > .item:nth-child(3)::after {
        content: '3';
        background-color:#0365f9;
    }
    
    .news > .menus > .list > .datas > .item:nth-child(4)::after {
        content: '4';
        background-color: #1890ff;
    }
    
    .news > .menus > .list > .datas > .item:nth-child(5)::after {
        content: '5';
        background-color: #4b93ec;
    }
    
    .news > .menus > .list > .datas > .item:nth-child(6)::after {
        content: '6';
        background-color: #6203f9;
    }
    
    .news > .menus > .list > .datas > .item:nth-child(7)::after {
        content: '7';
        background-color: #8217e4;
    }
    
    .news > .menus > .list > .datas > .item:nth-child(8)::after {
        content: '8';
        background-color: #a02bb5;
    }
    
    .news > .menus > .list > .datas > .item:nth-child(9)::after {
        content: '9';
        background-color:#9174d6;
    }

    .news > .menus > .list > .datas > .item:last-child {
        border-bottom: 0;
    }

    .news > .btn-menu {
        position: fixed;
        left: 11px;
        top: 89px;
        width: 40px;
        height: 40px;
        border: 1px solid #e8e8e8;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 2px 2px 5px #eee, -2px -2px 5px #eee;
        display: none;
        align-items: center;
        justify-content: center;

    }

    .news > .btn-menu:active {
        opacity: 0.7;
    }

    @media only screen and (max-width: 1050px) {
        .news {
            width: 100%;
            margin-top: 42px;
        }

        .news > .menus {
            position: absolute;
            width: 80%;
            background-color: #fff;
            box-shadow: 2px 2px 5px #ccc;
            border-radius: 8px;
            padding: 8px;
            display: none;
        }

        .news > .menus.show {
            display: flex;
        }

        .news > .router {
            margin: 0 12px;
        }

        .news > .btn-menu {
            display: flex;
        }
    }
</style>
